import React from 'react';
import ScrollReveal from '../common/ScrollReveal';

const HeroSection = () => {
  return (
    <section className="bg-black text-[#f5f5f7] h-[100vh] flex flex-col items-center justify-center text-center px-6 relative overflow-hidden">
      {/* Floating Ambient Backgrounds */}
      <div className="absolute top-1/4 -right-20 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[120px] animate-float-slow pointer-events-none"></div>
      <div className="absolute bottom-1/4 -left-20 w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[100px] animate-float-medium pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-orange-500/5 rounded-full blur-[150px] animate-pulse-slow pointer-events-none"></div>
      
      <div className="z-10 max-w-5xl flex flex-col items-center w-full">
        <ScrollReveal>
          <div className="inline-block">
            <span className="text-orange-500 font-bold tracking-[0.2em] text-xs uppercase mb-6 block animate-pulse"> <i style={{fontSize: "24px"}} className="fa-brands fa-apple"></i>Premium Retail & Wholesale</span>
          </div>

        </ScrollReveal>
        
        <ScrollReveal delay={200}>
          <h1 className="text-6xl md:text-9xl font-bold tracking-tighter mb-6 text-white animate-reduce-white">
            iSeries
          </h1>
        </ScrollReveal>
        
        <ScrollReveal delay={400}>
          <p className="text-xl md:text-3xl font-medium mb-12 text-gray-200 max-w-lg md:max-w-2xl mx-auto leading-relaxed animate-breathe">
            Premium Technology. Unmatched Experience.
          </p>
        </ScrollReveal>
      </div>
      
      {/* Abstract Product Silhouette */}
      <div className="absolute -bottom-32 w-full h-[300px] md:h-[400px] flex justify-center opacity-40 animate-float-drift pointer-events-none">
        <div className="w-[200px] md:w-[300px] h-[600px] bg-gradient-to-t from-[#1d1d1f] to-transparent rounded-t-[3rem] md:rounded-t-[4rem] border-t border-white/10 backdrop-blur-sm"></div>
      </div>
    </section>
  );
};

export default HeroSection;